import React from "react";
import type { ReactNode } from "react";
import { Checkbox as CheckboxAria } from "react-aria-components";
import type { CheckboxProps } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

import { indexedOptionStyles } from "./IndexedOption";
import { IndexedOptionContent } from "./IndexedOptionContent";

type IndexedCheckboxProps = {
  index: string;
  label: ReactNode;
} & Omit<CheckboxProps, "children">;

export function IndexedCheckbox({
  className,
  index,
  label,
  ...checkboxProps
}: IndexedCheckboxProps) {
  return (
    <CheckboxAria className={cn(indexedOptionStyles, className)} {...checkboxProps}>
      {({ isSelected }) => (
        <IndexedOptionContent index={index} isSelected={isSelected} label={label} />
      )}
    </CheckboxAria>
  );
}
